import clsx from 'clsx';
import styles from './TypeSelector.module.scss';

function TypeSelector({ options = [], selectedOptionId, changeSelectedOption }: any) {
    return (
        <div className={styles.TypeSelector}>
            {options.map((option: any) => {
                const isSelected = option.id === selectedOptionId;
                const iconUrl = isSelected ? option.iconSelected ?? option.icon : option.icon;
                return (
                    <div
                        className={clsx(styles.Option, { [styles.SelectedOption]: isSelected })}
                        key={option.id}
                        onClick={() => changeSelectedOption(option.id)}
                    >
                        {!!iconUrl && <img src={iconUrl} alt="" className={styles.Icon} />}
                        {option.label}
                    </div>
                );
            })}
        </div>
    );
}

export default TypeSelector;
